export default function PaymentSourceStats({ sourceStats, formatCurrency }) {
  const tataneu = sourceStats?.tataneu || {};
  const amazon = sourceStats?.amazon || {};
  return (
    <div className="card-flat" data-testid="source-stats-section">
      <h2 className="text-lg font-semibold mb-4">Payment Source Stats</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <SourceCard
          borderColor="#E90069" bg="bg-pink-50"
          badgeClass="badge-tataneu" badgeLabel="TataNeu" feeLabel="2.067% fee"
          stats={tataneu} formatCurrency={formatCurrency}
          feeClass="text-[#E90069]"
        />
        <SourceCard
          borderColor="#FF9900" bg="bg-orange-50"
          badgeClass="badge-amazon" badgeLabel="Amazon" feeLabel="0% fee"
          stats={amazon} formatCurrency={formatCurrency}
        />
      </div>
    </div>
  );
}

function SourceCard({ borderColor, bg, badgeClass, badgeLabel, feeLabel, stats, formatCurrency, feeClass = '' }) {
  return (
    <div className={`p-4 border ${bg}`} style={{ borderColor }}>
      <div className="flex items-center gap-2 mb-2">
        <span className={badgeClass}>{badgeLabel}</span>
        <span className="text-xs text-gray-500">{feeLabel}</span>
      </div>
      <div className="grid grid-cols-3 gap-4 text-center">
        <div>
          <div className="text-xs text-gray-500 uppercase">Bookings</div>
          <div className="font-mono font-bold">{stats?.count || 0}</div>
        </div>
        <div>
          <div className="text-xs text-gray-500 uppercase">Amount</div>
          <div className="font-mono font-bold">{formatCurrency(stats?.amount)}</div>
        </div>
        <div>
          <div className="text-xs text-gray-500 uppercase">Fee</div>
          <div className={`font-mono font-bold ${feeClass}`}>{formatCurrency(stats?.fee)}</div>
        </div>
      </div>
    </div>
  );
}
